import { render, staticRenderFns } from "./AddObject.vue?vue&type=template&id=0dadf589&scoped=true&"
import script from "./AddObject.vue?vue&type=script&lang=js&"
export * from "./AddObject.vue?vue&type=script&lang=js&"
import style0 from "./AddObject.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddObject.vue?vue&type=style&index=1&id=0dadf589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dadf589",
  null
  
)

export default component.exports